(function () {
  function initProductTabs() {
    var tabLinks = document.querySelectorAll('.pdp-tab-part .tablinks');
    var tabContent = document.querySelectorAll('.pdp-tab-part .tabcontent');

    if (!tabLinks.length) return;

    tabLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();

        var tabId = event.currentTarget.dataset.tab;
        var target = document.getElementById(tabId);
        if (!target) return;

        tabContent.forEach(function (content) {
          content.classList.remove('active');
        });

        tabLinks.forEach(function (el) {
          el.parentNode.classList.remove('active');
        });

        target.classList.add('active');
        event.currentTarget.parentNode.classList.add('active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs, { once: true });
  } else {
    initProductTabs();
  }
})();
